// extracted by mini-css-extract-plugin
export default {"tile_container":"nca","tile_img_container":"oca","not_recommended_label":"pca","modal_root":"qca","content":"rca","warning":"sca","x_mark":"tca","tile_img":"uca","tile_type":"vca","tile_product_title":"wca","tile_product_price":"xca","tile_descr_line":"yca","tile_descr_icon":"zca","info_icon":"Aca","tile_descr_text":"Bca","tile_btns_container":"Cca","info_container":"Eca","info_text":"Fca"};
    if(module.hot) {
      // 1738064244382
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  